// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fullwidth[data-v-52996552]{width:100%}.discount[data-v-52996552]{padding-bottom:5px}.discount span[data-v-52996552]{cursor:pointer;-webkit-text-decoration:underline;text-decoration:underline}.display-discount[data-v-52996552]{color:#3e4cd4;margin-top:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
